interface PriceCalculatorResult {
    formattedTotalPrice: string;
    formattedOriginalPrice: string;
}

function usePriceCalculator(
    numberOfLessons: number,
    lessonPrice: number,
    discount: number | undefined
): PriceCalculatorResult {
    const totalCoursePrice = numberOfLessons * lessonPrice;
    const totalDiscount = totalCoursePrice * (discount || 0) / 100;
    const formattedTotalPrice = totalCoursePrice - totalDiscount === Math.floor(totalCoursePrice - totalDiscount)
        ? (totalCoursePrice - totalDiscount).toFixed(0)
        : (totalCoursePrice - totalDiscount).toFixed(2);
    const originalCoursePrice = numberOfLessons * lessonPrice;
    const formattedOriginalPrice = originalCoursePrice === Math.floor(originalCoursePrice)
        ? originalCoursePrice.toFixed(0)
        : originalCoursePrice.toFixed(2);

    return { formattedTotalPrice, formattedOriginalPrice };
}

export default usePriceCalculator;
